import { setAmplitudeUserProperties, createMainEventProperties } from './utils';

const handleEvent = (amplitudeInstance, pageName, eventName, extraProperties) =>
  amplitudeInstance.logEvent(eventName, {
    ...createMainEventProperties(pageName),
    ...extraProperties,
  });

const logWithDefaultProperties = ({
  amplitudeInstance,
  pageName,
  eventName,
  extraProperties,
  userProperties,
}) => {
  setAmplitudeUserProperties(amplitudeInstance);

  if (userProperties) {
    amplitudeInstance.setUserProperties(userProperties);
  }

  handleEvent(amplitudeInstance, pageName, eventName, extraProperties);
};

export { handleEvent, logWithDefaultProperties };
